import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChildren,
} from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { responseMessageStatus, ResponseStatus } from '../../enum';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { Investment, Investor } from 'src/models/investment.model';
import { CommonResponseRecords, FieldId } from 'src/models/commomnModel.model';
import { Program } from 'src/models/program.model';
import {
  filterActivePrograms,
  filterProgramsForTransactionEdit,
} from '../../program-dropdown-filter';

interface ProductService {
  name: string;
}
@Component({
  selector: 'app-add-update-investments',
  templateUrl: './add-update-investments.component.html',
  styleUrls: ['./add-update-investments.component.scss'],
  standalone: false,
})
export class AddUpdateInvestmentsComponent implements OnInit {
  //#region properties
  isVisibleInvestmentDrawer: boolean = true;
  showProgramDrawer: boolean = false;
  showInvestorModal: boolean = false;
  isSubmittingInvestment: boolean = false;
  isSubmittingInvestmentSummary: boolean = false;
  isScheduledFuture: boolean = false;
  canEditProgram: boolean = false;
  currentInvestorData: Investor = null;
  currentConfirmingInvestment: Investment;
  selectedProgram: Program;
  currentProcessFee: number;
  currentDefaultProgram: Program;
  isInvestmentModal: string = 'invest';
  @Input() selectedData: Investment;
  @Input() investorsList: Array<Investor>;
  @Input() selectedInvestor: string;
  @Output() hideInvestmentModal = new EventEmitter();
  @Output() deleteInvestment = new EventEmitter();
  listOfInvestors: Array<Investor> = [];
  listOfProgramPeriods: Array<Program> = [];
  private allPrograms: Program[] = [];
  comment: string;
  siteId: string = '';
  netTerms: number = 30;
  today = new Date();
  currentDate = new Date();
  investmentModalTitle: string = 'Add Investment';
  yesterdayAsDate = new Date();
  yesterday = new Date(
    this.yesterdayAsDate.setDate(this.yesterdayAsDate.getDate() - 1)
  );
  nineMonths = new Date(
    this.currentDate.setMonth(this.currentDate.getMonth() + 9)
  );
  currentYear: number;
  lastYear: number;
  currentYearApiInvestorsData: any[] = [];
  lastYearApiInvestorsData: any[] = [];
  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    current <= this.yesterday ||
    current >= this.nineMonths ||
    (current.getDate() == this.nineMonths.getDate() &&
      current.getMonth() == this.nineMonths.getMonth());
  estArrivalDate: any;
  siteProcessFee: number = 0;
  siteNonAlcFee: number = 0;
  currentInvoiceAmount: number = 0;
  currentProductService: ProductService;
  subscription: Subscription[] = [];
  currentDefaultDescription: string;
  currentInvestment: Investment;
  toBeGrayedOut: boolean = false;
  canDeleteInvestment: boolean = true;
  isVisibleDeleteModal: boolean = false;
  isDeleting: boolean = false;
  siteNonAlcStatus: boolean = false;
  currentInvestorNonAlcStatus: boolean = false;

  canAddInvestor: boolean = false;
  canAddProgramTag: boolean = false;
  @ViewChildren('amount') amount: FieldId;
  @ViewChildren('programPeriod') programPeriod: FieldId;
  investorParentRefId: string = '';
  siteDetails: any;
  isInvestorFormVisible: boolean = false;
  //#endregion

  //constructor
  constructor(
    public _cS: CommonService,
    public _fS: FormService,
    public _cpS: CommonPagesService,
    public _iS: InnerPagesService,
    private route: ActivatedRoute,
    private currency: CurrencyPipe,
    private _router: Router,
    private _datepipe: DatePipe
  ) {
    _fS.investmentForm_fb();
    this.nineMonths.setDate(this.nineMonths.getDate() + 1);
  }

  //#region functions
  ngOnInit(): void {
    //get program period
    this._cS.programsListObserver.next('call');

    this.currentYear = new Date().getFullYear();
    this.lastYear = new Date().getFullYear() - 1;

    this._cS.updateSiteDetails.next('call');

    this.today.setHours(0, 0, 0, 0);
    //get site id for URL
    this.siteId = this.route.snapshot.paramMap.get('siteId');

    this.canEditProgram = this._iS.canAccessProgramsTags().canEditProgramTag;
    this.canDeleteInvestment =
      this._iS.canAccessInvestments().canDeleteInvestment;

    this.canAddInvestor = this._iS.canAccessInvestors().canAddInvestor;
    this.canAddProgramTag = this._iS.canAccessProgramsTags().canAddProgramTag;
    if (this.investorsList) {
      this.listOfInvestors = this.investorsList;
    }
    // this.loadPrograms();
    this.subscription.push(
      this._cS.listOfProgramPeriods.subscribe((res) => {
        if (res != null) {
          this.allPrograms = res;
          // Do not rebuild dropdown while Manage drawer is open (preserves drawer list mutations).
          if (!this.showProgramDrawer) {
            this.refreshProgramDropdown();
          }
          const defaultProgram = this.listOfProgramPeriods.find(
            (x: any) => x.isDefault
          );
          if (defaultProgram && this.selectedData == null) {
            this.currentDefaultProgram = defaultProgram;
            this._fS.investmentForm.patchValue({
              programPeriod: defaultProgram?.id,
            });
            this.selectedProgram = defaultProgram;
          }
        }
      }),
      this._cS.agencySiteDetails.subscribe((res: any) => {
        if (res) {
          this.siteDetails = res;
          this.siteProcessFee = Number(res.Processfee.split('%')[0]);
          this.siteNonAlcFee = Number(res.NonAlcFee.split('%')[0]);
          this.siteNonAlcStatus = res.NonAlcStatus;
        }
      })
    );
    if (this.selectedInvestor) {
      this._fS.investmentForm.patchValue({
        investor: this.selectedInvestor,
      });
      this.fetchInvestorHistory(this.selectedInvestor);
      this._cpS.isInvestmentHisoryLoading = false;
    }
    if (this.selectedData != null) {
      this.investmentModalTitle = 'Edit Investment';
      this.patchDataToModal();
    } else {
      this._fS.investmentForm.patchValue({
        scheduledDate: new Date(),
      });
      this.currentProcessFee =
        this.siteNonAlcStatus && this.currentInvestorNonAlcStatus
          ? this.siteNonAlcFee
          : this.siteProcessFee;
      this.getInvestmentDescription();
    }
    this.getSiteService();
  }
  getSiteService() {
    this._cpS
      .getSiteService(this.siteId)
      .subscribe((response: CommonResponseRecords<ProductService>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.currentProductService = response.result;
        }
      });
  }
  getInvestmentDescription() {
    this._cpS.GetInvestmentDescription().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.currentDefaultDescription = response.result;
        this._fS.investmentForm.patchValue({
          description: response.result,
        });
      }
    });
  }
  patchDataToModal() {
    this._cpS
      .getInvestmentById(this.selectedData.id)
      .subscribe((response: CommonResponseRecords<Investment>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.currentInvestment = response.result;
          this.refreshProgramDropdown();
          const inv = this.listOfInvestors.find(
            (x: any) => x._id == this.currentInvestment.repId
          );
          const program = this.listOfProgramPeriods.find(
            (x: any) => x.id == this.currentInvestment.program.id
          );
          this.selectedProgram = program;
          this._fS.investmentForm.patchValue({
            investor: inv ? this.currentInvestment.repId : '',
            programPeriod: program ? this.currentInvestment.program.id : '',
            amount: this.currentInvestment.amount,
            scheduledDate: this.currentInvestment.scheduleDate,
            description: this.currentInvestment.description,
          });
          this.formatAmount(this._fS.investmentForm.get('amount').value);
          this.comment = this.currentInvestment.comment;
          this.currentProcessFee = this.currentInvestment?.processfee;
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }

  handleCancel(investmentdata: any, toRedirectSummary = false) {
    if (toRedirectSummary || investmentdata == null) {
      this.isVisibleInvestmentDrawer = false;
    }
    this.hideInvestmentModal.emit({
      hide: this.isVisibleInvestmentDrawer,
      data: investmentdata != null ? investmentdata : null,
    });

    if (!toRedirectSummary) {
      this.pre();
      this._fS.investmentForm.reset();
      this._fS.investmentForm.patchValue({
        scheduledDate: new Date(),
        description: this.currentDefaultDescription,
        programPeriod: this.currentDefaultProgram?.id,
      });
    }
    this.comment = '';
  }

  index = 'First-content';
  current = 0;

  //click back
  pre(): void {
    this.current -= 1;
    this.changeContent();
  }

  //click next
  next(): void {
    if (this._fS.investmentForm.valid) {
      const formvalue = this._fS.investmentForm.value;
      //check if anything changed in edit
      if (this.selectedData) {
        const currentDate = (this.selectedData.ScheduleDate = moment
          .utc(this.selectedData.ScheduleDate)
          .toDate());
        if (
          formvalue.investor == this.selectedData.RepId &&
          formvalue.programPeriod == this.currentInvestment.program.id &&
          formvalue.amount ==
            this.currency.transform(this.selectedData.Amount) &&
          formvalue.description == this.currentInvestment.description &&
          this._datepipe.transform(formvalue.scheduledDate, 'MM/dd/yyyy') ==
            this._datepipe.transform(currentDate, 'MM/dd/yyyy')
        ) {
          this.toBeGrayedOut = true;
        } else {
          this.toBeGrayedOut = false;
        }
      }

      new Date(this._fS.investmentForm.get('scheduledDate').value).setHours(
        0,
        0,
        0,
        0
      );
      this.current += 1;
      this.changeContent();
      this.estArrivalDate = new Date(
        this._fS.investmentForm.value.scheduledDate
      );
      if (this.currentInvestorData.isInvoice) {
        this.estArrivalDate.setDate(
          this.estArrivalDate.getDate() + this.netTerms
        );
      } else {
        this.estArrivalDate.setDate(
          this.estArrivalDate.getDate() + this.netTerms + 14
        );
      }
      if (
        new Date(this._fS.investmentForm.get('scheduledDate').value) >
        new Date()
      ) {
        this.isScheduledFuture = true;
      } else {
        this.isScheduledFuture = false;
      }
      let amount = this._fS.investmentForm.value.amount;
      if (amount?.toString().includes('$')) {
        amount = amount.split('$')[1];
      }
      amount = amount?.toString().replace(',', '');
      this.currentInvoiceAmount = Number(amount);
    } else {
      this._cS.markFormGroupTouched(this._fS.investmentForm);
    }
  }
  programPeriodChange(event: { id: string }) {
    if (event) {
      this.amount.first.nativeElement.focus();
    }
    const selectedProgram = this.listOfProgramPeriods.find(
      (x: any) => x.id == event
    );
    this.selectedProgram = selectedProgram;    
  }

  formatAmount(amount) {
    if (amount) {
      if (amount?.toString().includes('$')) {
        amount = amount.split('$')[1];
      }
      amount = amount?.toString().replace(',', '');
      this.currentInvoiceAmount = Number(amount);
      this._fS.investmentForm.patchValue({
        amount: this.currency.transform(amount),
      });
    }
  }

  done(toRedirectSummary: boolean): void {
    if (toRedirectSummary) {
      this.isSubmittingInvestmentSummary = true;
    } else {
      this.isSubmittingInvestment = true;
    }
    const utcStart = moment(this._fS.investmentForm.get('scheduledDate').value)
      .utc()
      .format();

    const formvalue = this._fS.investmentForm.value;
    const selectedInvestor = this.listOfInvestors.find(
      (x: any) => x._id == formvalue.investor
    );
    const investmentData: Investment = {
      siteId: this.siteId,
      invester: {
        id: formvalue.investor,
        name: selectedInvestor.InvestorDisplayName,
      },
      program: {
        id: formvalue.programPeriod,
        name: this.selectedProgram.label,
      },
      amount: this.currentInvoiceAmount
        ? Number(this.currentInvoiceAmount)
        : formvalue.amount,
      processingFee: (this.currentInvoiceAmount * this.currentProcessFee) / 100,
      scheduleDate: utcStart,
      description: formvalue.description,
      comment: this.comment,
      estimatedArrivalDate: this.estArrivalDate,
    };

    if (this.selectedData) {
      investmentData['id'] = this.selectedData.id;
      this.editInvestment(investmentData, toRedirectSummary);
    } else {
      this.addInvestment(investmentData, toRedirectSummary);
    }
  }

  editInvestment(investmentData: Investment, toRedirectSummary?: boolean) {
    this._cpS
      .updateInvestment(investmentData)
      .subscribe((response: CommonResponseRecords<Investment>) => {
        if (response.responseStatus == ResponseStatus.success) {
          const newInvestmentData = response.result;
          this.isVisibleInvestmentDrawer = false;
          if (toRedirectSummary) {
            this.isSubmittingInvestmentSummary = false;
          } else {
            this.isSubmittingInvestment = false;
          }
          const newData = {
            id: newInvestmentData.id,
            CompanyName: newInvestmentData.companyName,
            Amount: newInvestmentData.amount,
            RepName: newInvestmentData.repName,
            ScheduleDate: newInvestmentData.scheduleDate,
            Stage: newInvestmentData.stage,
            PaybevInvestmentStatus: newInvestmentData.paybevInvestmentStatus,
          };
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
          this.handleCancel(newData, toRedirectSummary);
        } else {
          if (toRedirectSummary) {
            this.isSubmittingInvestmentSummary = false;
          } else {
            this.isSubmittingInvestment = false;
          }
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }

  addInvestment(investmentData: any, toRedirectSummary?: any) {
    this._cpS.scheduleInvestment(investmentData).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        const newInvestment = response.result;
        if (toRedirectSummary) {
          this.isSubmittingInvestmentSummary = false;
        } else {
          this.isSubmittingInvestment = false;
        }
        const newData = {
          _id: newInvestment.id,
          CompanyName: newInvestment.companyName,
          Amount: newInvestment.amount,
          RepName: newInvestment.repName,
          ScheduleDate: newInvestment.scheduleDate,
          Stage: newInvestment.stage,
          PaybevInvestmentStatus: newInvestment.paybevInvestmentStatus,
        };
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
        this.handleCancel(newData, toRedirectSummary);
      } else {
        if (toRedirectSummary) {
          this.isSubmittingInvestmentSummary = false;
        } else {
          this.isSubmittingInvestment = false;
        }
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  navigateToSummary() {
    this._router.navigate(['/paybev/' + this.siteId + '/summary']);
  }
  createNewInvestor() {
    this.showInvestorModal = true;
    this.isInvestorFormVisible = false;
  }

  newCreatedInvestor(event: {
    isVisibleInvestorDrawer: boolean;
    data: Investor;
  }) {
    this.showInvestorModal = event.isVisibleInvestorDrawer;
    if (event.data) {
      this.listOfInvestors?.splice(0, 0, event.data);
      this.listOfInvestors[0]._id = event.data.id;
      this.listOfInvestors[0].CompanyName = event.data.companyName;
      this.showInvestorModal = false;
      this.listOfInvestors[0].InvestorDisplayName =
        event.data.investorDisplayName;
      this._fS.investmentForm.patchValue({
        investor: this.listOfInvestors[0]._id,
      });
    }
  }

  private refreshProgramDropdown(): void {
    const selectedProgramId =
      this.currentInvestment?.program?.id ??
      this._fS.investmentForm.get('programPeriod')?.value ??
      null;
    this.listOfProgramPeriods =
      this.selectedData == null
        ? filterActivePrograms(this.allPrograms)
        : filterProgramsForTransactionEdit(
            this.allPrograms,
            selectedProgramId
          );
  }

  newAddedProgram(event: { data: Program }) {
    if (event.data) {
      if (event.data.isDefault) {
        this._fS.investmentForm.patchValue({
          programPeriod: event.data.id,
        });
        this.listOfProgramPeriods.map((x: any) => (x.isDefault = false));
        event.data.isDefault = true;
        this.currentDefaultProgram = event.data;
      } else if (event.data.isVisible) {
        this.listOfProgramPeriods?.splice(0, 0, event.data);
      } else {
        this.listOfProgramPeriods = this.listOfProgramPeriods.filter(
          (x: any) => x.id !== event.data.id
        );
      }
    }
  }
  addUpdateProgram(event: any) {
    if (event.isNewData) {
      if (event.data.isVisible) {
        this.listOfProgramPeriods?.splice(0, 0, event.data);
      }
    } else {
      const allIndex = this.allPrograms.findIndex(
        (x) => x.id == event.data.id
      );
      if (allIndex >= 0) {
        this.allPrograms[allIndex].label = event.data.label;
      }
      const existingIndex = this.listOfProgramPeriods.findIndex(
        (x: any) => x.id == event.data.id
      );
      if (existingIndex >= 0) {
        this.listOfProgramPeriods[existingIndex].label = event.data.label;
      }
    }
  }

  handleCancelInvestor() {
    this.showInvestorModal = false;
  }

  manageProgramPeriod() {
    this.isInvestmentModal = 'invest';
    this.showProgramDrawer = true;
  }

  changeContent(): void {
    switch (this.current) {
      case 0: {
        this.index = 'First-content';
        break;
      }
      case 1: {
        this.index = 'Second-content';
        break;
      }
      default: {
        this.index = 'error';
      }
    }
  }

  fetchInvestorHistory(option: string) {
    if (option) {
      this._cpS.currentInvestorDetails.next(null);

      this.programPeriod?.first?.focus();

      this._cpS.isInvestmentHisoryLoading = true;

      this._iS.getInvestorDetails(option).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cpS.isInvestmentHisoryLoading = false;
          this.currentInvestorData = response.result;
          this.currentInvestorNonAlcStatus = response.result.isNonAlc;
          this.currentProcessFee =
            this.siteNonAlcStatus && this.currentInvestorNonAlcStatus
              ? this.siteNonAlcFee
              : this.siteProcessFee;
          this.getInvestorTerms(option);
          this._cpS.currentInvestorDetails.next(this.currentInvestorData);
          if (!this.selectedData) {
            this._fS.investmentForm.patchValue({
              description: this.currentInvestorData.supplierDescription
                ? this.currentInvestorData.supplierDescription
                : this.currentDefaultDescription,
            });
          }
        } else {
          this._cpS.isInvestmentHisoryLoading = false;
        }
      });
    }
  }
  getInvestmentHistory(investorId: string) {
    if (investorId) {
      this._cpS.isInvestmentHisoryLoading = true;

      // this.investorParentRefId = this.listOfInvestors.find(
      //   (x) => x._id == investorId
      // )?.ParentRefId;
      const currentInvestor = this.listOfInvestors.find(
        (x) => x._id == investorId
      );
      this.investorParentRefId = currentInvestor?.ParentRefId;
      this.currentInvestorNonAlcStatus = currentInvestor?.IsNonAlc;

      if (this.investorParentRefId) {
        this._iS
          .getInvestmentHistory(this.investorParentRefId, this.siteId)
          .subscribe((response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this.currentYearApiInvestorsData = response.result.find(
                (x: any) => x.year == this.currentYear
              )?.records;

              this.lastYearApiInvestorsData = response.result.find(
                (x: any) => x.year == this.lastYear
              )?.records;
              this._cpS.isInvestmentHisoryLoading = false;
              this._cS.investmentHistoryRecords.next({
                currentYearData: this.currentYearApiInvestorsData,
                lastYearData: this.lastYearApiInvestorsData,
              });
            } else {
              this._cpS.isInvestmentHisoryLoading = false;
              this.currentYearApiInvestorsData = [];
              this.lastYearApiInvestorsData = [];
            }
          });
      }
    }
  }

  handleCancelDelete() {
    this.isVisibleDeleteModal = false;
  }
  deleteTransaction() {
    this.isVisibleInvestmentDrawer = false;
    this.deleteInvestment.emit(this.selectedData.id);
    this.isVisibleDeleteModal = false;
  }

  getInvestorTerms(option: string) {
    if (this.currentInvestorData?.investorsId) {
      this._cpS.getInvestorTerms(option).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.netTerms = response.result ? response.result : 30;
        }
      });
    }
  }

  handleCancelProgram() {
    this.showProgramDrawer = false;
  }

  ngOnDestroy(): void {
    this.subscription.map((s) => s.unsubscribe());
  }
  //#endregion
}
